import { Tool } from '../types';

export const mockTools: Tool[] = [
  {
    id: '1',
    name: 'DeWalt Cordless Drill',
    description: 'Powerful 20V cordless drill with two batteries, perfect for home projects. This drill features variable speed control, a comfortable grip, and comes with a set of drill bits for various materials. The long-lasting battery ensures you can complete projects without interruption.',
    categories: ['Power Tools', 'Hand Tools'],
    pricePerDay: 15,
    imageUrl: 'https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    location: 'Midtown, New York',
    availability: 'Available now',
    rating: 4.8,
    reviews: 24,
    owner: {
      id: 'user1',
      name: 'David Wallace',
      avatar: 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=60&h=60&dpr=2',
      rating: 4.9,
    },
  },
  {
    id: '2',
    name: 'Husqvarna Chainsaw',
    description: 'Professional-grade chainsaw, ideal for cutting trees and large branches. Features a powerful engine and comes with safety equipment. This chainsaw has been well-maintained and is in excellent working condition.',
    categories: ['Power Tools', 'Outdoor', 'Garden & Lawn'],
    pricePerDay: 35,
    imageUrl: 'https://images.pexels.com/photos/1598073/pexels-photo-1598073.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    location: 'Brooklyn, New York',
    availability: 'Available next week',
    rating: 4.5,
    reviews: 12,
  },
  {
    id: '3',
    name: 'Pressure Washer',
    description: 'High-pressure cleaning system perfect for decks, driveways, and siding. This powerful machine makes cleaning outdoor surfaces quick and easy. It comes with multiple nozzle attachments for different cleaning tasks.',
    categories: ['Cleaning', 'Outdoor'],
    pricePerDay: 25,
    imageUrl: 'https://images.pexels.com/photos/2244746/pexels-photo-2244746.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    location: 'Queens, New York',
    availability: 'Available on weekends',
    rating: 4.7,
    reviews: 18,
  },
  {
    id: '4',
    name: 'Circular Saw',
    description: 'Corded circular saw for precise cutting of wood and other materials. Features adjustable depth and angle settings for versatile use. Comes with two extra blades for different materials.',
    categories: ['Power Tools', 'Hand Tools'],
    pricePerDay: 18,
    imageUrl: 'https://images.pexels.com/photos/3846249/pexels-photo-3846249.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    location: 'Bronx, New York',
    availability: 'Available now',
    rating: 4.3,
    reviews: 9,
  },
  {
    id: '5',
    name: 'KitchenAid Stand Mixer',
    description: 'Professional stand mixer for baking and cooking. Includes multiple attachments for various food preparation tasks. This high-quality mixer is perfect for making bread, cakes, and other baked goods.',
    categories: ['Kitchen', 'Appliances'],
    pricePerDay: 20,
    imageUrl: 'https://images.pexels.com/photos/4109850/pexels-photo-4109850.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    location: 'Manhattan, New York',
    availability: 'Available Tue-Fri',
    rating: 5.0,
    reviews: 15,
  },
  {
    id: '6',
    name: 'Ladder - 8 ft',
    description: 'Sturdy aluminum ladder, extends up to 8 feet. Perfect for painting, cleaning gutters, or any task requiring extra height. This ladder is lightweight yet durable and easy to transport.',
    categories: ['Home Improvement', 'Outdoor'],
    pricePerDay: 12,
    imageUrl: 'https://images.pexels.com/photos/273244/pexels-photo-273244.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    location: 'Staten Island, New York',
    availability: 'Available now',
    rating: 4.6,
    reviews: 11,
  },
  {
    id: '7',
    name: 'Lawn Mower',
    description: 'Self-propelled gas lawn mower, ideal for medium to large yards. Features multiple cutting height options and a grass collection bag. This mower is easy to start and maneuver, making lawn care a breeze.',
    categories: ['Garden & Lawn', 'Outdoor'],
    pricePerDay: 22,
    imageUrl: 'https://images.pexels.com/photos/1448353/pexels-photo-1448353.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    location: 'Long Island, New York',
    availability: 'Available weekends',
    rating: 4.4,
    reviews: 8,
  },
  {
    id: '8',
    name: 'Air Compressor',
    description: 'Portable air compressor with multiple attachments for inflating tires, operating air tools, and more. This versatile tool is perfect for DIY projects and automotive tasks. It\'s quiet yet powerful.',
    categories: ['Power Tools', 'Automotive'],
    pricePerDay: 16,
    imageUrl: 'https://images.pexels.com/photos/8005397/pexels-photo-8005397.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    location: 'Hoboken, New Jersey',
    availability: 'Available now',
    rating: 4.2,
    reviews: 7,
  },
  {
    id: '9',
    name: 'Carpet Cleaner',
    description: 'Professional-grade carpet cleaner for deep cleaning carpets and upholstery. Removes tough stains and odors with powerful suction and cleaning solution. Great for refreshing your home\'s carpets or preparing for special events.',
    categories: ['Cleaning', 'Home Improvement'],
    pricePerDay: 30,
    imageUrl: 'https://images.pexels.com/photos/4107282/pexels-photo-4107282.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    location: 'Jersey City, New Jersey',
    availability: 'Available now',
    rating: 4.9,
    reviews: 14,
  },
  {
    id: '10',
    name: 'Electric Sander',
    description: 'Orbital sander for smooth finishing of wood surfaces. Variable speed control for different materials and projects. Comes with multiple grit sandpapers and a dust collection bag to keep your workspace clean.',
    categories: ['Power Tools', 'Hand Tools'],
    pricePerDay: 14,
    imageUrl: 'https://images.pexels.com/photos/3637730/pexels-photo-3637730.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    location: 'Brooklyn, New York',
    availability: 'Available now',
    rating: 4.5,
    reviews: 10,
  },
  {
    id: '11',
    name: 'Plumbing Snake',
    description: 'Professional drain auger for clearing clogged drains and pipes. 25-foot cable reaches deep into pipes to remove stubborn blockages. Save money on plumber calls with this easy-to-use tool.',
    categories: ['Plumbing', 'Home Improvement'],
    pricePerDay: 15,
    imageUrl: 'https://images.pexels.com/photos/8486972/pexels-photo-8486972.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    location: 'Queens, New York',
    availability: 'Available now',
    rating: 4.3,
    reviews: 6,
  },
  {
    id: '12',
    name: 'Tile Cutter',
    description: 'Manual tile cutter for ceramic and porcelain tiles. Makes clean, precise cuts for your tiling projects. Perfect for bathroom or kitchen renovations. Includes measuring guides for accurate cuts.',
    categories: ['Hand Tools', 'Home Improvement'],
    pricePerDay: 18,
    imageUrl: 'https://images.pexels.com/photos/4492100/pexels-photo-4492100.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    location: 'Bronx, New York',
    availability: 'Available weekdays',
    rating: 4.6,
    reviews: 9,
  },
];

export const mockFeaturedTools = mockTools.filter(tool => tool.featured);